export default{
  wards: (state) => state.wards,
  wardTo: (state) => state.wardTo,
  wardFrom: (state) => state.wardFrom,
  ward: (state) => state.ward
}



// WEBPACK FOOTER //
// ./src/components/ward/store/getters.js